import React, { useState, useEffect } from 'react';
import { sixYardAxios } from '../../../sixYardAxios';
import qs from "qs";
import classes from './myAccount.module.css';
import InputField from '../../containers/inputField/inputField';
import Button from '../../containers/button/button';
import Profile from '../../../assets/images/profile-edit.png';
import Pencil from '../../../assets/images/Pencil.png';
import Remove from '../../../assets/images/RedXIcon.png';
import Gallery from '../../../assets/images/ImageIcon.png';
import Camera from '../../../assets/images/CameraIcon.png';
import PromptMessage from '../../containers/promptMessage/promptMessage';

const MyAccount = (props) => {
    const [enableInput, setEnableInput] = useState(false);
    const [avatar, setAvatar] = useState(Profile);
    const [errorAvatar, setErrorAvatar] = useState(false);
    const [successAvatar, setSuccessAvatar] = useState(false);
    const [menuVisible, setMenuVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [account, setAccount] = useState({});
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [controls, setControls] = useState({
        fullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: 'Enter Name',
            },
            value: "",
            validation: {
                required: true,
            },
            label: "Full Name",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: 'Enter Email',
            },
            value: "",
            label: "Email",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: '07xxxxxxxx',
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: "Phone Number",
            valid: false,
            touched: false
        },
    });

    useEffect(() => {
        fetchAccount();
    }, []);
    // useEffect(() => {
    //     const handleOutsideClick = (e) => {
    //         if (menuVisible && !e.target.closest(`.${classes.FloatingMenu}`)) {
    //             setMenuVisible(false);
    //         }
    //     };
    //     document.addEventListener('click', handleOutsideClick);
    //     return () => document.removeEventListener('click', handleOutsideClick);
    // }, [menuVisible]);
    const fetchAccount = async () => {
        try {
            const res = await sixYardAxios.get("/profile");
            const fetchedAccount = res.data.data.basic_info;
            setAccount(fetchedAccount);
            setAvatar(fetchedAccount.avatar || Profile);            
            // Update controls with fetched account data
            setControls(prevControls => ({
                ...prevControls,
                fullName: {
                    ...prevControls.fullName,
                    value: fetchedAccount.full_name || '',
                    elementConfig: {
                        ...prevControls.fullName.elementConfig,
                        placeholder: fetchedAccount.full_name || 'Enter Name',
                    },
                    valid: true // Assume valid after fetching data
                },
                email: {
                    ...prevControls.email,
                    value: fetchedAccount.email || 'Enter Email',
                    valid: true // Assume valid after fetching data
                },
                phone: {
                    ...prevControls.phone,
                    value: {    
                        dialCode: fetchedAccount.phone?.slice(0, fetchedAccount.phone.indexOf(fetchedAccount.phone.match(/\d/))),
                        number: fetchedAccount.phone?.replace(/[^0-9]/g, ""),
                    },
                    valid: true // Assume valid after fetching data
                },
            }));
        } catch (error) {
            // console.error(error.response.data);
        }
    };
    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }

    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
                disabled={enableInput ? false : true}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    const inputChangedHandler = (event, controlName) => {
        // Check if the control being updated is the phone input
        if (controlName === 'phone') {
            const updatedControls = {
                ...controls,
                [controlName]: {
                    ...controls[controlName],
                    value: event, // 'event' is the phone number string returned by PhoneInput
                    valid: checkValidity(event, controls[controlName].validation),
                    touched: true
                }
            };
            setControls(updatedControls);
        } else {
            // For other inputs, proceed normally
            const updatedControls = {
                ...controls,
                [controlName]: {
                    ...controls[controlName],
                    value: event.target.value, // For normal inputs
                    valid: checkValidity(event.target.value, controls[controlName].validation),
                    touched: true
                }
            };
            setControls(updatedControls);
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        sixYardAxios
            .post("/profile/update", {
                name: controls.fullName.value,
                email: controls.email.value,
                phone: controls.phone.value.dialCode + controls.phone.value.number,
            }) // send JSON directly
            .then(res => {
                setEnableInput(false);
                setSuccess(true);
                fetchAccount();
                window.location.reload();
            })
            .catch(err => {
                setError(err.response?.data?.message || "Something went wrong");
            });
    };

    const cancelEditAccount = () => {
        setEnableInput(false);
        setControls(prevControls => ({
            ...prevControls,
            fullName: {
                ...prevControls.fullName,
                value: account.full_name || '',
                elementConfig: {
                    ...prevControls.fullName.elementConfig,
                    placeholder: account.full_name || 'Enter Name',
                },
                valid: true // Assume valid after fetching data
            },
            email: {
                ...prevControls.email,
                value: account.email || 'Enter Email',
                valid: true // Assume valid after fetching data
            },
            phone: {
                ...prevControls.phone,
                value:  {    
                    dialCode: account.phone?.slice(0, account.phone.indexOf(account.phone.match(/\d/))),
                    number: account.phone?.replace(/[^0-9]/g, ""),
                },
                valid: true // Assume valid after fetching data
            },
        }));
    }
    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
    };
    const handleGallery = () => {
        setMenuVisible(false);
        updateProfileImage();
    };

    const handleCamera = () => {
        setMenuVisible(false);
        // Placeholder for camera functionality
        console.log("Camera option clicked");
    };

    const handleRemovePhoto = () => {
        setMenuVisible(false);
        removeProfileImage();
    };
    const updateProfileImage = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*'; // Accept only images
        fileInput.onchange = async (event) => {
            const selectedFile = event.target.files[0];
            if (selectedFile) {
                const formData = new FormData();
                formData.append('avatar', selectedFile);
                try {
                    setLoading(true);
                    const res = await sixYardAxios.post('/profile/avatar', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    setAvatar(res.data.data.avatar); // Update avatar with the new URL
                    setSuccessAvatar(res.data.data.message);
                    window.location.reload();
                    // setLoading(false);
                } catch (error) {
                    setErrorAvatar(error.response.data.message);
                    // setLoading(false);
                }
            }
        };
        fileInput.click();
    };
    const removeProfileImage = async () => {
        try {
            setLoading(true);
            const res = await sixYardAxios.delete('/profile/avatar');
            setAvatar(Profile);
            setSuccessAvatar(res.data.message);
            setLoading(false);
        } catch (error) {
            setErrorAvatar(error.response.data.message);
            setLoading(false);
        }
    };

    return (
        <div className={classes.FormLayout}>
            <form className={classes.Form} onSubmit={(e) => submitHandler(e)}>
                <div className={classes.ProfileImage}>
                    <img src={avatar} alt='profile' />
                    <div className={classes.PencilContainer} onClick={toggleMenu} >
                        <img src={Pencil} alt='pencil' />
                    </div>
                    {menuVisible &&
                        <div className={classes.FloatingMenu}>
                            <div className={classes.Overlay} onClick={() => setMenuVisible(false)} />
                            <div className={classes.FloatingMenuButton}>
                                <button onClick={handleGallery}>
                                    <img src={Gallery} alt="Gallery" /> Gallery
                                </button>
                                <button onClick={handleCamera}>
                                    <img src={Camera} alt="Camera" /> Camera
                                </button>
                                <button onClick={handleRemovePhoto}>
                                    <img src={Remove} alt="Remove" /> Remove Photo
                                </button>
                            </div>
                        </div>
                    }
                </div>
                {form}
                {!enableInput ? <Button content='EDIT' onClick={() => setEnableInput(true)} /> :
                    <div className={classes.Buttons}>
                        <Button content='CANCEL' whiteBackground onClick={cancelEditAccount} />
                        <Button content='SAVE' type='submit' />
                    </div>
                }
            </form>
            {errorAvatar && <PromptMessage message={errorAvatar} status='Oops' button='CLOSE' click={() => setErrorAvatar(false)} />}
            {successAvatar && <PromptMessage message={successAvatar} status='CONGRATULATIONS' successMessage button='CLOSE' click={() => setSuccessAvatar(false)} />}
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
            {success && <PromptMessage message="Updated successfully" status='CONGRATULATIONS' successMessage button='CLOSE' click={() => setSuccess(false)} />}
        </div>
    )
}

export default MyAccount;